export function AboutPage() {
  return (
    <div className="container" style={{ paddingBlock: "2rem", maxWidth: 720 }}>
      <h2>About BeforeMainstream</h2>
      <p style={{ color: "var(--fg-muted)", marginTop: "1.5rem", fontSize: "1.05rem" }}>
        BeforeMainstream is a discovery engine for emerging clothing and footwear brands.
        It scans public sources, analyzes brand identity, detects style signals and places each
        brand into a searchable map of categories, tags and aesthetics.
      </p>
      <p style={{ color: "var(--fg-muted)", marginTop: "1rem" }}>
        The first version is not a personal stylist and not a shopping app. It is a living brand radar —
        built to surface brands you would not easily find through normal shopping, Google, Instagram or
        mainstream fashion media.
      </p>
      <h3 style={{ marginTop: "2.5rem", fontFamily: "var(--font-serif)" }}>What we do</h3>
      <ul style={{ color: "var(--fg-muted)", lineHeight: 1.8, paddingLeft: "1.25rem", marginTop: "0.75rem" }}>
        <li>Scan curated sources, stockists and search results for emerging brands.</li>
        <li>Extract structured brand information from public web pages.</li>
        <li>Categorize each brand by product, style direction and aesthetic.</li>
        <li>Score each brand on discovery, mainstream, momentum and confidence.</li>
        <li>Publish high-confidence brands automatically, route the rest to review.</li>
      </ul>
      <h3 style={{ marginTop: "2.5rem", fontFamily: "var(--font-serif)" }}>What we don't do</h3>
      <ul style={{ color: "var(--fg-muted)", lineHeight: 1.8, paddingLeft: "1.25rem", marginTop: "0.75rem" }}>
        <li>Sell ranking. Brands cannot pay to rank higher.</li>
        <li>Republish copyrighted content. We link to the source.</li>
        <li>Track personal style attributes — that's a v2 feature, only with consent.</li>
      </ul>
    </div>
  );
}
